import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import {AuthService} from "../services/auth.service";

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = async (
    route,
    state
) => {
    const router: Router = inject(Router);
    const authService: AuthService = inject(AuthService);

    var isUserLoggedIn = await authService.isAuthenticated();

    if(isUserLoggedIn) {
        return router.parseUrl('');
    }

    return true;
};
